import React, { useContext, useEffect, useState } from "react";
import Navbar from "./navbar";

import RegisterForm from './register_form'
import axios from 'axios';
import { BounceLoader, BarLoader, BeatLoader } from 'react-spinners'


import { Link, useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';
import { url } from "../weburl"
    ;
import emailjs from '@emailjs/browser'
import { init } from '@emailjs/browser';
import { PedShareForm } from "./pedshareus";
import CountryContext from "./country_context";
import { SupplyPhoneNumber, SupplyPhoneNumberDialog } from "./modals/supply-phone-number-popup";
import { RegisterModal } from "./modals/register-modal";

export function withRouter(Child) {
    return (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return <Child {...props} navigate={navigate} params={params} location={location} />;
    }

}

const DogRegistration = (props) => {
    const context = useContext(CountryContext)
    const [dog, setDog] = useState({

    })
    const [toBeEditted, setToBeEditted] = useState(false)
    const [loaded, setloaded] = useState(true)
    const [image_urls, setimage_urls] = useState()
    const [dpoLoaded, setdpoLoaded] = useState(false)
    const [phoneNumberModal, setphoneNumberModal] = useState(false)
    const [imageSelected, setImageSelected] = useState()
    const [expresspay, setExpressPay] = useState()
    const [expresspayloaded, setExpressPayLoaded] = useState(false)
    const [sire, setSire] = useState("")
    const [dam, setDam] = useState("")
    const [registerModalOpen, setRegisterModalOpen] = useState(true)
    const [submittedData, setSubmittedData] = useState(false)
    const [loggedIn, setLoggedIn] = useState(true)
    const [ready, setReady] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        check_if_to_edit()
    }, [])

    useEffect(() => {
        if (!context.user) {
            setLoggedIn(false)
            console.log('not context.user', context.user)
        }
        else {
            setLoggedIn(true)
            console.log('context.user updated', context.user)
        }

    }, [context.user])

    useEffect(() => {
        if (context.user_sql_details && !context.user_sql_details.phone_number) {
            setphoneNumberModal(true)
        }
    }, [context.user_sql_details])

    useEffect(() => {
        if (toBeEditted) {
            axios
                .get(`${url}api/dogs/${props.params.dog_id}`)
                .then((res) => {
                    setDog(res.data)
                })
                .catch((err) => {
                    console.log("Error couldn't create Dog");
                    console.log(err.message);
                });
        }
    }, [toBeEditted])

    const check_if_to_edit = () => {
        for (let i = 0; i < props.location.pathname.split('/').length; i++) {
            if (props.location.pathname.split('/')[i] === 'edit') {
                setToBeEditted(true)
                console.log('to be editted')
            } else {
                console.log('banjo')
            }
        }


    }

    useEffect(() => {
        if (ready && !toBeEditted) {
            console.log('here in ready and to be editted')
            sendDogInfo()
        }
        if (ready && toBeEditted) {
            updateDogInfo()
        }
    }, [ready])

    const uploadImage = () => {
        const formData = new FormData()
        formData.append('file', imageSelected)
        formData.append('upload_preset', 'gwxgv5ii')

        axios.post('https://api.cloudinary.com/v1_1/daurieb51/image/upload', formData)
            .then((response) => {
                setDog({ ...dog, public_id: response.data.public_id })
                setReady(true)
                console.log('responseeeee', response.data.public_id)
                console.log('image successfuly uploaded thank you jehovah')
            })

    }


    const handleImageChange = (e) => {

        setDog({ ...dog, image_url: e.target.files[0].name })
        setImageSelected(e.target.files[0])
        // addImageSelected(e))


    }
    const handleChange = (e) => {
        e.preventDefault()
        const { name, value } = e.target
        setDog({ ...dog, [name]: e.target.value })


    }

    const handleSireSelect = (fieldName, id, dogName) => {
        setDog({ ...dog, [fieldName]: id })
        if ([fieldName] == 'sire') {
            setSire(dogName)
        }
        if ([fieldName] == 'dam') {
            setDam(dogName)
        }
    }

    useEffect(() => {
        if (expresspay) {
            window.location = expresspay
        }
    }, [expresspay])
    const getTransactUrl = () => {

        axios.post(`${url}api/expresspaygh/transact`, {
            location: context.location,
            transaction_name: props.transaction_name,
            transaction_cost: props.params.price,
            dog_name: dog.name,
            username: context.user.displayName,
            email: context.user.email
        })
            .then((res) => {
                console.log(res.data)
                setExpressPayLoaded(true)
                setExpressPay(res.data)

            })

            .catch((err) => console.log(err))
    }



    const edit = (e) => {

        e.preventDefault()
        if (imageSelected) {
            uploadImage(updateDogInfo)

            console.log('image url  presnet, ready to eedit')

        }
        else {
            updateDogInfo()
            console.log('no image url present, ready to edit')
        }



    }

    const updateDogInfo = () => {
        axios
            .put(`${url}api/dogs/${props.params.dog_id}`, dog)
            .then((res) => {

                console.log(res.data.message);
                console.log('editeed')
                if (props.redirectToAdmin) {
                    props.navigate(`/admin/dogs-detail/${props.params.dog_id}`)
                }
                else {
                    props.navigate('/profile')

                }

            })
            .catch((err) => {
                console.log("Error couldn't edit Dog");
                console.log(err.message);
            });
    }

    const sendDogInfo = () => {
        axios
            .post(`${url}api/dogs`, { dog: dog, user: context.user })
            .then((res) => {

                // sendDogRegEmail()
                console.log(res.data.message);
                console.log('dog created/editted')

                if (!props.specialRegistration) {
                    getTransactUrl()
                }
                else {
                    setHasBeenPaidFor()
                }

            })
            .catch((err) => {
                console.log("Error couldn't create Dog");
                console.log(err.message);
            });
    }

    const setHasBeenPaidFor = () => {
        axios
            .post(`${url}api/dogs/has_paid`, {
                dog: {
                    name: dog.name || 'no name supplied'
                }
            })
            .then((res) => {
                navigate('/admin')
            }
            )
            .catch((err) => console.log(err))

    }


    const submit = (e) => {

        e.preventDefault()
        if (dog.image_url) {
            uploadImage()
        }
        else {
            sendDogInfo()
        }
        setSubmittedData(true)

    }


    return (

        <div className='row align-items-center justify-content-center dog_reg_full'>
            <Navbar color='white' navbar_dark={'navbar-dark'} />

            <div className="container-fluid py-5">
                <div className="row align-items-start justify-content-center">

                    {props.specialRegistration ?
                        <div className="px-5 font-weight-bold">
                            SPECIAL REGISTRATION
                        </div>
                        :
                        <div className="col-md-3 py-5 FORM  
                             text-left px-5  mx-sm-0 mb-2 mb-lg-0">
                            <PedShareForm label="Please upload pedigree so that we fill it for you if a dog's 
                            name does not appear in the drop down when searching for your sire/dam." pedigree={true} />
                        </div>
                    }

                    <div className="col-md-7 ">
                        {toBeEditted ?
                            <RegisterForm dog={dog}
                                submit={edit}
                                handleChange={handleChange}
                                image_urls={image_urls}
                                sire={sire}
                                dam={dam}
                                uploadImage={uploadImage}
                                handleImageChange={handleImageChange}
                                handleSireSelect={handleSireSelect}

                                edit={true}
                            />
                            :
                            <RegisterForm dog={dog}
                                image_urls={image_urls}
                                handleImageChange={handleImageChange}

                                sire={sire}
                                dam={dam}
                                uploadImage={uploadImage}
                                submit={submit} handleChange={handleChange}
                                getdogid={props.getdogid}
                                getnameofDog={props.getnameofDog}
                                handleSireSelect={handleSireSelect}



                            />


                        }

                    </div>
                    {/* } */}



                    {phoneNumberModal && <SupplyPhoneNumberDialog open={phoneNumberModal} />
                    }

                    {!loggedIn &&
                        <RegisterModal open={registerModalOpen} submittedModal={false} />
                    }

                    {context.user && submittedData &&
                        <RegisterModal open={true} submittedModal={true} />
                    }



                </div>

            </div>


        </div>






    )



}

export default withRouter(DogRegistration);